import { combineReducers } from 'redux';
import reduceReducers from 'reduce-reducers';
import { reducer as formReducer } from 'redux-form';

import requirements from './reducers/requirements';
import noteTemplates, { INoteTemplateState } from './reducers/note_templates';
import studentApplications, {
  IStudentApplicationStoreState,
} from './reducers/student_applications';
import jsonapiHelper from './reducers/jsonapi_helper';
import invoiceSidebar, { IInvoiceSidebarState } from './reducers/invoice_sidebar';
import custom_fields, { ICustomFieldsStoreState } from './reducers/custom_fields';
import ielts_modal, { IIeltsModalState } from './reducers/ielts_modal';
import rolesReducer, { IRolesStore } from './reducers/roles';
import modals from './reducers/modals_reducer';
import search, { ISearchStoreState } from './reducers/search';

import { IActionObject } from './action_creators';

import crossSliceReducer from './profile_page/reducers/crossSliceReducer';
import pageReducer from './profile_page/reducers/pageReducer';
import cardReducer from './profile_page/reducers/cardReducer';
import schoolInfo from './profile_page/reducers/schoolInfoReducer';
import stats from './profile_page/reducers/statReducer';
import location from './profile_page/reducers/locationReducer';
import alumni from './profile_page/reducers/alumniReducer';
import filterOptions from './profile_page/reducers/filterOptionsReducer';
import profileReducer from './profile_page/reducers/profileReducer';
import pageOptionsReducer from './profile_page/reducers/pageOptionsReducer';

export interface IBaseDocument<T = any, TRelationships = void> {
  id: number | string;
  type: string;
  attributes?: T;
  relationships?: TRelationships;
}

export interface IEntityPrototype<T = IBaseDocument> {
  [intKey: number]: T;
  [strKey: string]: T;
}

export interface IRequirementEntityAttributes {
  status: string;
  official: boolean;
  applyproof_compatible: boolean;
  verification_status: string;
}

export type IVerifiedDocumentEntities = IEntityPrototype<
  IBaseDocument<{ relatedEntities?: Array<{ type: string; id: string | number }>; createdAt?: any }>
>;
export type IRequirementsEntities = IEntityPrototype<IBaseDocument<IRequirementEntityAttributes>>;

export type IEntities = {
  verified_document?: IVerifiedDocumentEntities;
  application_disclaimer_requirements?: IRequirementsEntities;
  application_receipt_requirements?: IRequirementsEntities;
  application_questions_requirements?: IRequirementsEntities;
  application_document_requirements?: IRequirementsEntities;
  application_payment_requirements?: IRequirementsEntities;
  [key: string]: unknown;
};

const appReducer = combineReducers({
  api: jsonapiHelper,
  requirements,
  noteTemplates,
  studentApplications,
  invoiceSidebar,
  custom_fields,
  ielts_modal,
  rolesReducer,
  form: formReducer,
  modals,
  search,

  // Profile
  page: pageReducer,
  card: cardReducer,
  schoolInfo,
  stats,
  location,
  alumni,
  filterOptions,
  pageOptions: pageOptionsReducer,
  profile: profileReducer,
});

export type IReduxState = {
  api: {
    entities: IEntities;
    requests: any;
  };
  form: any;
  custom_fields: ICustomFieldsStoreState;
  ielts_modal: IIeltsModalState;
  invoiceSidebar: IInvoiceSidebarState;
  noteTemplates: INoteTemplateState;
  rolesReducer: IRolesStore;
  search: ISearchStoreState;
  studentApplications: IStudentApplicationStoreState;
  page: any;
  card: any;
  schoolInfo: any;
  stats: any;
  location: any;
  alumni: any;
  filterOptions: any;
  pageOptions: any;
  profile: any;
};

const rootReducer = (_state: IReduxState, action: IActionObject): IReduxState => {
  const state = action.type === '@CLEAR' ? undefined : _state;
  return appReducer(state, action);
};

export default reduceReducers(rootReducer, crossSliceReducer);
